import { Loader } from "@atoms/loader/Loader";
import Typography from "@atoms/typography/Typography";
import { gridStyles } from "@layout/grid";
import { useDebounce } from "@utils/debounce/use-debounce";
import { cn } from "@utils/tailwind";
import { FC, useEffect, useState } from "react";
import { Hit, HitData } from "../hit";
import { AnimatedSpan } from "./AnimatedSpan";

export type HitsProps = {
  isFetching: boolean;
  hits?: HitData[];
  show?: boolean;
  hasMoreHits?: boolean;
};

export const SearchHits: FC<HitsProps> = ({
  isFetching,
  hits,
  show = true,
  hasMoreHits,
}) => {
  // myIsFetching is a hack to override initial isFetching=true state.
  // Otherwise we'll see unexpected spinner if we start typing immediately after the page load
  const [myIsFetching, setMyIsFetching] = useState(false);
  useEffect(() => setMyIsFetching(true), []);

  const debounceIsFetching = useDebounce(myIsFetching && isFetching, 1000);
  const showLoader = isFetching && debounceIsFetching;

  const results = [
    `${hits?.length || 0}`,
    hits?.length === 1 ? "result" : "results",
    hasMoreHits ? "and more" : "",
  ].join(" ");

  if (!show) return null;
  return (
    <>
      <div className={gridStyles.container}>
        <Typography
          tag="p"
          variant="base"
          weight="medium"
          className={cn(
            gridStyles.itemShrinked,
            "relative mb-2 text-grey-faded md:mb-3 lg:mb-4"
          )}
        >
          <AnimatedSpan
            key="loader"
            show={showLoader}
            className="absolute left-0 top-1 size-4"
          >
            <Loader size={4} />
          </AnimatedSpan>
          <AnimatedSpan key="results" show={!isFetching}>
            {results}
          </AnimatedSpan>
          {/* 👇 Little hack to fix layout shift because of a zero height while fetching */}
          &nbsp;
        </Typography>
      </div>
      {hits?.map((it) => <Hit key={it.id} data={it} isFetching={isFetching} />)}
    </>
  );
};
